var _g, _path, _path2, _circle, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82,
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M55.694 81.791c13.83 1.212 26.05-9.387 27.295-23.672C84.233 43.834 74.03 31.272 60.2 30.061c-13.83-1.21-26.05 9.388-27.295 23.673-1.245 14.285 8.958 26.846 22.788 28.057z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.022 73.998a1.617 1.617 0 0 1-1.095-.466 1.462 1.462 0 0 1-.436-1.063v-3.064l-1.275-.243c-.345-.063-.62-.116-.888-.189a7.295 7.295 0 0 1-3.777-2.426 6.701 6.701 0 0 1-1.515-4.088v-.601c0-.4-.015-.794 0-1.182a1.43 1.43 0 0 1 .493-.942c.282-.245.65-.38 1.032-.38s.75.135 1.032.38c.282.244.457.58.492.942.018.352 0 .697 0 1.041v.691a3.915 3.915 0 0 0 1.22 2.758c.766.735 1.8 1.16 2.888 1.187.542.016 1.088.025 1.638.027.637 0 1.275 0 1.91-.027a4.358 4.358 0 0 0 2.719-.967 3.975 3.975 0 0 0 1.422-2.405 3.855 3.855 0 0 0-.544-2.711 4.19 4.19 0 0 0-2.254-1.738c-1.118-.372-2.245-.728-3.376-1.087l-.451-.143c-1.051-.33-2.103-.658-3.146-1.002a7.281 7.281 0 0 1-3.708-2.523A6.698 6.698 0 0 1 47 49.65a6.704 6.704 0 0 1 1.452-4.11 7.292 7.292 0 0 1 3.738-2.483c.286-.07 1.53-.32 1.53-.32l.766-.16v-3.064a1.391 1.391 0 0 1 .095-.566c.07-.18.178-.347.317-.487.139-.141.305-.255.49-.334.186-.079.385-.122.588-.127.208-.002.414.034.606.108.193.074.369.183.517.321.143.136.256.298.333.476.077.178.117.368.116.56V42.7l.85.088a7.54 7.54 0 0 1 4.439 1.996 6.794 6.794 0 0 1 1.584 2.19A6.51 6.51 0 0 1 65 49.576v1.722c0 .386-.161.756-.448 1.03a1.572 1.572 0 0 1-1.083.426c-.406 0-.795-.154-1.082-.427a1.42 1.42 0 0 1-.448-1.029V49.626a3.894 3.894 0 0 0-1.224-2.802 4.306 4.306 0 0 0-2.94-1.175 59.567 59.567 0 0 0-1.755-.024c-.592 0-1.182 0-1.786.024a4.356 4.356 0 0 0-2.699.99 3.974 3.974 0 0 0-1.399 2.407c-.162.92.021 1.866.518 2.672a4.145 4.145 0 0 0 2.2 1.733c1.839.62 3.683 1.194 5.528 1.762l1.117.344a7.341 7.341 0 0 1 4.04 2.59 6.721 6.721 0 0 1 1.432 4.428 6.773 6.773 0 0 1-1.81 4.302 7.418 7.418 0 0 1-4.248 2.266l-1.363.199v2.967c.027.207.009.417-.052.617s-.164.386-.302.547c-.131.15-.293.274-.474.364-.182.09-.38.146-.585.163l-.115-.002z",
    fill: "url(#c)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 27,
    stroke: "url(#d)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M62.187 81.536c5.248-1.224 9.987-4.116 13.535-8.26a26.37 26.37 0 0 0 6.213-14.8 26.381 26.381 0 0 0-3.49-15.67c-2.758-4.71-6.909-8.397-11.856-10.534a27.87 27.87 0 0 1 9.52 11.25 28.675 28.675 0 0 1 2.56 14.66 28.665 28.665 0 0 1-5.118 13.974 27.853 27.853 0 0 1-11.364 9.38z",
    fill: "#6AC34B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.999,
    y1: 27.75,
    x2: 56.07,
    y2: 82.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 55.521,
    y1: 26.074,
    x2: 56.358,
    y2: 84.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 56,
    y1: 28,
    x2: 56,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -24,
    y: -24,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1181_139764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1181_139764",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBalance);
export default __webpack_public_path__ + "static/media/darkBalance.3849aca7ecb20cbdf7b25e76736004bf.svg";
export { ForwardRef as ReactComponent };